import { format } from "./format";

/**
 * @type {{format: (x: number) => string}}
 */
export const Nmbr = {
  format
};
